import React, { useId } from 'react';

import { SuggestAutocomplete } from '@src/components/ui';

import FieldShell from './FieldShell';


/**
 * Base suggest field — label above, free-text-with-suggestions combobox, helper/
 * error line below. Same chrome as SelectField / AutocompleteField but renders
 * `SuggestAutocomplete`, where the value IS the typed string and `options` are
 * non-binding suggestions. Receives RHF field props (value/onChange/onBlur/name/
 * ref) plus `error` (bool) and `helperText` from the generic wrapper. Only the
 * props SuggestAutocomplete reads are forwarded; RHF's `onBlur`/`name` are
 * intentionally not passed.
 */
const SuggestField = React.forwardRef((props, ref) => {
  const {
    label,
    value = '',
    onChange,
    error = false,
    suggested = false,
    helperText = ' ',
    className,
    options = [],
    placeholder,
    loading = false,
    disabled = false,
    emptyText,
    ...restProps
  } = props;

  const generatedId = useId();
  const id = restProps.id || generatedId;

  return (
    <FieldShell
      id={id}
      label={label}
      className={className}
      suggested={suggested}
      helperText={helperText}
      error={error}
    >
      <SuggestAutocomplete
        ref={ref}
        id={id}
        value={value}
        invalid={error}
        disabled={disabled}
        emptyText={emptyText}
        options={options}
        loading={loading}
        onChange={onChange}
        placeholder={placeholder}
      />
    </FieldShell>
  );
});

SuggestField.displayName = 'SuggestField';
export default SuggestField;
